module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-2-Inactive-ClubPilates-c8fbc146a9d8d6687baeb19f6dde7b9f.png";